import Reveal from "./Reveal";

const LOGOS = [
  { name: "Miilanche", src: "/customers/Miilanche.jpg" },
  { name: "Mysore Raman Idli", src: "/customers/MYSORE RAMAN IDLI.png" },
  { name: "Penì", src: "/customers/peni.png" },
  { name: "Scandy", src: "/customers/SCANDY.webp" },
  { name: "Sign Laban", src: "/customers/Sign Laban.jpg" },
  { name: "Sithara Silks", src: "/customers/Sithara Silks.jpeg" },
  { name: "Snow Fantasy", src: "/customers/Snow Fantasy.png" },
  { name: "Sound Bits", src: "/customers/SOUND BITS LOGO.png" },
  { name: "Thaal Kitchen", src: "/customers/Thaal Kitchen.png" },
  { name: "Thomsun Music House", src: "/customers/Thomsun Music House.png" },
  { name: "Tone Zone", src: "/customers/TONE ZONE LOGO.png" },
  { name: "Upasana Studio", src: "/customers/UPASANA STUDIO.png" },
  { name: "Western Lady", src: "/customers/WESTERN LADY.jpg.jpeg" },
  { name: "YA Supplements", src: "/customers/YA Supplements.jpg" },
  { name: "Bada Bazar", src: "/customers/Bada Bazar.png" },
  { name: "B Apple Store", src: "/customers/Br apple store.png" },
  { name: "Dunes Mart", src: "/customers/Dunes Mart.jpg" },
  { name: "GAGA Luxe", src: "/customers/GAGA LUXE.jpg" },
  { name: "George & Elsa", src: "/customers/GEORGE & ELSA.jpg" },
  { name: "G.O.D", src: "/customers/GOD.jpeg" },
  { name: "Jeans House", src: "/customers/Jeans House.jpg" },
  { name: "Lets Vivify", src: "/customers/LETS VIVIFY.png" },
  { name: "Hooman's Pet Stories", src: "/customers/Hooman's Pet Stories.png" },
];

const LogoChip = ({ logo }) => (
  <div
    className="shrink-0 mx-3 sm:mx-4 h-24 w-44 sm:h-28 sm:w-52 rounded-xl bg-white border border-[#DDE6F0] flex items-center justify-center p-5 shadow-[0_4px_16px_rgba(11,37,69,0.06)] transition-all duration-300 hover:shadow-[0_10px_28px_rgba(21,101,192,0.18)] hover:-translate-y-1 hover:border-[#00B4D8]/40 group"
    title={logo.name}
  >
    <img
      src={logo.src}
      alt={logo.name}
      loading="lazy"
      className="max-h-full max-w-full object-contain transition-all duration-500 grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100"
    />
  </div>
);

export const CustomerMarquee = () => {
  // Split into two rows for visual richness, with opposite directions
  const half = Math.ceil(LOGOS.length / 2);
  const rowA = LOGOS.slice(0, half);
  const rowB = LOGOS.slice(half);

  return (
    <section data-testid="customer-marquee" className="bg-white gi-section overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="text-center mb-12">
            <span className="font-mono text-xs uppercase tracking-widest text-[#1565C0]">Our Customers</span>
            <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl mt-3">
              Trusted by leading brands across India
            </h2>
            <p className="text-[#6B7280] mt-4 max-w-2xl mx-auto">
              From bridal couture to supermarkets, music houses to amusement parks — businesses of every kind run on DigiPOS.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal>
        <div className="gi-marquee-mask">
          <div className="gi-marquee gi-marquee-left">
            <div className="gi-marquee-track">
              {[...rowA, ...rowA].map((l, i) => (
                <LogoChip key={`a-${i}`} logo={l} />
              ))}
            </div>
          </div>

          <div className="gi-marquee gi-marquee-right mt-5">
            <div className="gi-marquee-track">
              {[...rowB, ...rowB].map((l, i) => (
                <LogoChip key={`b-${i}`} logo={l} />
              ))}
            </div>
          </div>
        </div>
      </Reveal>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-12 text-center">
        <p className="text-sm text-[#6B7280]">
          + thousands more retailers, distributors and service businesses across every industry
        </p>
      </div>
    </section>
  );
};

export default CustomerMarquee;
